import React from 'react'

function WallSlotWSD() {
  return (
    <embed src="\pdfs\E1.2.8_WSD_Wall_slot_diffuser_12.2013_kr.pdf" width="100%" height="2100px" />
)
}

export default WallSlotWSD